import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicCitiesList } from '~/swr-hooks/filters/usePublicCitiesList';

type PublicCitiesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicCitiesSelect = memo(({ boardId, ...props }: PublicCitiesSelectProps) => {
  const { shortId } = useShortIdContext();
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicCitiesList({
    search: debouncedSearchValue,
    shortId,
    boardId,
  });

  return (
    <StringSelect
      placeholder="Search for city"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicCitiesSelect.displayName = 'PublicCitiesSelect';
